import React from 'react';
import type { TEhrMeta } from '../../constants';
import s from './s.module.less';

// EHR 品牌色徽标（原型 ehrBadge）：StepEhrScope 已连接行 / GrantAccessModal 卡片头共用
export default function EhrBadge({ ehr }: { ehr: TEhrMeta }) {
    return (
        <span className={s.badge} style={{ background: `${ehr.color}1f`, color: ehr.color }}>
            {ehr.abbr}
        </span>
    );
}
